<h1 mat-dialog-title class="text-center">Add Serial</h1>
<div mat-dialog-content class="contentt">
    <div class="card s-card1">
        <div class="card-body">
            <div class="row">
                <div class="col-md-2">
                    <label for="" class="label1">Item Code</label>
                    <label for="" class="label2">CC235325</label>
                </div>
                <div class="col">
                    <label for="" class="label1">Item Description</label>
                    <label for="" class="label2">Coca Cola 1.25 l Soft Drink</label>
                </div>
                <div class="col">
                    <label for="" class="label1">Warehouse Code</label>
                    <label for="" class="label2">DL09210312</label>
                </div>
                <div class="col-md-2">
                    <label for="" class="label1">Total Qty Needed</label>
                    <label for="" class="label2">500</label>
                </div>
            </div>
        </div>
    </div>
  <div class="entry-forms mt-4">
    <div class="tabledesign">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="s_no">
          <th mat-header-cell *matHeaderCellDef> S.No. </th>
          <td mat-cell *matCellDef="let row">1</td>
        </ng-container>
        <ng-container matColumnDef="mfr_serial_no">
            <th mat-header-cell *matHeaderCellDef> Mfr Serial No. </th>
            <td mat-cell *matCellDef="let row"> 
              <mat-form-field class="field-bottom-0 my-2" appearance="outline" >
                <input type="text" matInput>
              </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="serial_no">
            <th mat-header-cell *matHeaderCellDef> Serial No. </th>
            <td mat-cell *matCellDef="let row"> 
              <mat-form-field class="field-bottom-0 my-2" appearance="outline">
                <input type="text" matInput>
              </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="lot_no">
            <th mat-header-cell *matHeaderCellDef> Lot No. </th>
            <td mat-cell *matCellDef="let row"> 
              <mat-form-field class="field-bottom-0 my-2" appearance="outline" >
                <input type="text" matInput>
              </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="admission_date">
            <th mat-header-cell *matHeaderCellDef> Admission Date </th>
            <td mat-cell *matCellDef="let row"> 
                <mat-form-field class="field-bottom-0 my-2" appearance="outline">
                    <!-- <mat-label></mat-label> -->
                    <input matInput [matDatepicker]="picker2">
                    <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="mfg_date">
            <th mat-header-cell *matHeaderCellDef> Mfg Date </th>
            <td mat-cell *matCellDef="let row"> 
                <mat-form-field class="field-bottom-0 my-2" appearance="outline">
                    <!-- <mat-label></mat-label> -->
                    <input matInput [matDatepicker]="picker1">
                    <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="expiration_date">
            <th mat-header-cell *matHeaderCellDef> Expiration Date </th>
            <td mat-cell *matCellDef="let row"> 
                <mat-form-field class="field-bottom-0 my-2" appearance="outline">
                    <!-- <mat-label></mat-label> -->
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="mfr_warranty_start">
            <th mat-header-cell *matHeaderCellDef> Mfr Warranty Start </th>
            <td mat-cell *matCellDef="let row"> 
                <mat-form-field class="field-bottom-0 my-2" appearance="outline">
                    <!-- <mat-label></mat-label> -->
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="mfr_warranty_end">
            <th mat-header-cell *matHeaderCellDef> Mfr Warranty End </th>
            <td mat-cell *matCellDef="let row"> 
                <mat-form-field class="field-bottom-0 my-2" appearance="outline">
                    <!-- <mat-label></mat-label> -->
                    <input matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </td>
        </ng-container>
        <tr mat-header-row  *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: this.displayedColumns;"></tr>
      </table>
    </div>
    <div class="mt-2">
        <button mat-stroked-button color="primary" class="me-1">+ Add New Batch</button>
        <button mat-stroked-button color="primary" (click)="openDialog()">Automatic Serial Creation</button>
    </div>
  </div>
</div>
<div mat-dialog-actions>
    <div class="row w-100">
        <div class="col-md-6">
            <div class="pt-2 d-flex ps-3 it-selection-hint fs-8">
                <div class="">
                    <span class="me-2">
                        Total Serial Created::
                    </span>
                    <span class="fw-600">3</span>
                </div>
            </div>
        </div>
        <div class="col-md-6 text-end">
            <button mat-raised-button color="primary" mat-dialog-close>Save</button>
        </div>
    </div>
</div>